<template>
    <!-- 新增编辑门店相册组件 -->
    <div>
        <a-modal
        centered
        :maskClosable="false"
        :destroyOnClose="true"
        :title="title"
        :visible="visible"
        :confirmLoading="confirmLoading"
        @cancel="cancel"
        @ok="ok"
        >
            <a-form :form="form">
                <a-form-item label="相册名称" :label-col="{span: 7}" :wrapper-col="{span: 16}">
                    <a-input :maxLength="5" v-decorator="['name', {rules: [{required: true,max: 5, message: '请输入相册名称（5字以内）'}]}]" placeholder="请输入">
                        <span slot="suffix">{{form.getFieldValue('name') ? form.getFieldValue('name').length : 0}}/5</span>
                    </a-input>
                </a-form-item>
                <a-form-item label="是否展示为门店设施" :label-col="{span: 7}" :wrapper-col="{span: 16}">
                    <a-radio-group v-decorator="['isEquipment', {initialValue: true}, {rules: [{required: true, message: '请选择内部跳转类型',}]}]">
                        <a-radio :value="true">是</a-radio>
                        <a-radio :value="false">否</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="相册描述名称" :label-col="{span: 7}" :wrapper-col="{span: 16}">
                    <a-input :maxLength="10" v-decorator="['displayName', {rules: [{max: 10, message: '请输入相册描述名称（10字以内）'}]}]" placeholder="请输入">
                        <span slot="suffix">{{form.getFieldValue('displayName') ? form.getFieldValue('displayName').length : 0}}/10</span>
                    </a-input>
                </a-form-item>
                <a-form-item label="相册描述" :label-col="{span: 7}" :wrapper-col="{span: 16}">
                    <a-textarea :maxLength="200" type="textarea" :rows="4"  v-decorator="['description', {rules: [{max: 200,  message: '请输入相册描述（200字以内）'}]}]" placeholder="请输入" />
                    <div class="textarea-size text-right">{{form.getFieldValue('description') ? form.getFieldValue('description').length : 0}}/200</div>
                </a-form-item>
                <a-form-item label="设施icon选择" :label-col="{span: 7}" :wrapper-col="{span: 16}" :required="form.getFieldValue('isEquipment')" v-if="form.getFieldValue('isEquipment')">
                    <div class="checked-icon" v-if="iconObj.url">
                        <img :src="iconObj.url" alt="">
                        <div>{{iconObj.displayName}}</div>
                    </div>
                    <a class="text-primary ml8" @click="visibleIcon = true">选择icon</a>
                </a-form-item>
            </a-form>
        </a-modal>
        <a-modal
        centered
        title="icon选择"
        :maskClosable="false"
        :destroyOnClose="true"
        :visible="visibleIcon"
        :width="900"
        @cancel="visibleIcon = false"
        @ok="chooseIcon"
        >
            icon名称： <a-input v-model="iconName" style="width:200px" /> <a-button type="primary" class="ml16" @click="getIconDetail">查询</a-button> <a-button @click="reSet">重置</a-button>
            <ul class="icon-list">
                <li class="icon-list-item" v-for="item in iconList" :key="item.id" @click="checkedIcon(item)">
                    <a-checkbox :checked="item.checked"/>
                    <img style="width:32px;height:30px" :src="item.url" alt="">
                    <div>{{item.displayName}}</div>
                </li>
            </ul>
        </a-modal>
    </div>
</template>

<script>
    export default {
        name: "addAlbum",
        zh: "新增编辑门店相册",
        components: {
        },
        props: {
        },
        data() {
            return {
                form: this.$form.createForm(this),
                visible: false,
                confirmLoading: false,
                iconList: [],
                id: '',
                title: '新建相册',
                visibleIcon: false,
                iconName: '',
                iconObj: {},
                dataDetail: {}
            }
        },
        computed: {},
        watch: {},
        methods: {
            open(data) {
                this.getIconDetail();
                this.visible = true;
                this.title = '新建相册';
                this.id = data.id;
                if(this.id) {
                    this.dataDetail = data;
                    this.title = '编辑相册';
                    let formValue = {
                        name: this.dataDetail.name,
                        isEquipment: this.dataDetail.isEquipment,
                        displayName: this.dataDetail.displayName,
                        description: this.dataDetail.description,
                    };
                    this.$nextTick(() => {
                        this.form.setFieldsValue(formValue)
                    })
                }
            },
            ok() {
                this.form.validateFields((errors, values) => {
                    if (Boolean(errors) || this.confirmLoading) {
                        return false;
                    };
                    values.iconId = values.isEquipment ? this.iconObj.id : '';
                    if(values.isEquipment && !values.iconId) {
                        this.$message.error('请选择icon')
                        return
                    }
                    this.confirmLoading = true;
                    this.$api.storedPhoto[this.id ? 'editAlbum' : 'addAlbum']({
                        body: {
                            id: this.id,
                            shopId: this.$route.params.id,
                            ...values
                        }
                    }).then(res => {
                        this.confirmLoading = false;
                        this.$message.success('操作成功！');
                        this.cancel();
                    }).catch(err => {
                        this.confirmLoading = false;
                    })
                });
            },
            cancel() {
                this.visible = false;
                this.iconObj = {};
                this.$emit('cancel');
            },
            /**
             * @func getIconDetail 获取图标
             */
            getIconDetail() {
                this.$api.storedPhoto.getIcon({
                    query: {
                        name: this.iconName
                    }
                }).then(res => {
                    res.map(item => item.checked = false)
                    if(this.title == '编辑相册') {
                        this.iconObj = this.dataDetail.iconId ? (res.filter(item => item.id == this.dataDetail.iconId).length > 0 ? res.filter(item => item.id == this.dataDetail.iconId)[0] : {}) : {}
                    }
                    this.iconList = res;
                });
            },
            reSet() {
                this.iconName = '';
                this.getIconDetail()
            },
            checkedIcon(item) {
                this.iconList.map(item => item.checked = false)
                item.checked = true;
            },
            chooseIcon() {
                let icon =  this.iconList.filter(item => item.checked);
                if(icon.length == 0) {
                    this.$message.error('请选择icon')
                    return
                }
                this.iconObj = icon[0];
                this.visibleIcon = false;
            },
        }
    };
</script>

<style lang="scss">
.ant-modal-body {
    padding-right: 8px;
}
.icon-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 24px;
    &-item {
        margin-right: 16px;
        margin-bottom: 16px;
        padding-top: 16px;
        width: 80px;
        height: 80px;
        text-align: center;
        background-color: #f8f8f8;
        border-radius: 5px;
        position: relative;
        cursor: pointer;
        >img {
            margin-bottom: 5px;
        }
        .ant-checkbox-wrapper {
            position: absolute;
            right: 0;
            top: -3px;
        }
    }
}
.checked-icon {
    margin-top: -24px;
    padding-top: 12px;
    float: left;
    width: 80px;
    height: 80px;
    text-align: center;
    background-color: #f8f8f8;
    border-radius: 5px;
}
</style>
